import { urls } from '@repo/app-constants';
import { useQuery } from '@tanstack/react-query';
import { apiName } from 'assets';
import { useSelector } from 'react-redux';
import { API } from '../../../src/api';
import { getMainAccountId } from '../../store/account';

export interface OptimizelyAttributes {
  email?: string;
  admin?: boolean;
  role?: string;
  hasMembership?: boolean;
  loggedInLast30Days?: boolean;
  hasLatestResultsReady?: boolean;
  hasKitWithPractitioner?: boolean;
  hasKitWithPartner?: boolean;
  hasKitWithAmazonPartner?: boolean;
  hasKitWithConferencePartner?: boolean;
  hasVagKit?: boolean;
  mainAccountAudience?: string;
}

async function fetchOptimizelyAttributes(): Promise<OptimizelyAttributes> {
  const response = await API.get(
    apiName,
    `${urls.apiBasePath}/features/attributes/optimizely`,
  );

  return response || {};
}

const useOptimizelyAttributes = () => {
  const mainAccountId = useSelector(getMainAccountId);

  const {
    data: attributes,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['optimizely-attributes', mainAccountId],
    queryFn: fetchOptimizelyAttributes,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!mainAccountId,
  });

  return {
    attributes: attributes ?? {},
    isLoading,
    error,
  };
};

export default useOptimizelyAttributes;
